const countData = [
  {
    "letter": "aik",
    "harf": "ایک",
    "soundFile": "aik.mp3",
    "words": [
      {
        "word": "ایک پھول",
        "imageFile": "aik_01.jpg",
        "soundFile": "aik_01.mp3"
      },
      {
        "word": "ایک چڑیا",
        "imageFile": "aik_02.jpg",
        "soundFile": "aik_02.mp3"
      },
      {
        "word": "ایک کبوتر",
        "imageFile": "aik_03.jpg",
        "soundFile": "aik_03.mp3"
      },
      {
        "word": "ایک کتاب",
        "imageFile": "aik_04.jpg",
        "soundFile": "aik_04.mp3"
      },
      {
        "word": "ایک کینو",
        "imageFile": "aik_05.jpg",
        "soundFile": "aik_05.mp3"
      },
      {
        "word": "ایک ہاتھی",
        "imageFile": "aik_06.jpg",
        "soundFile": "aik_06.mp3"
      }
    ]
  },
  {
    "letter": "do",
    "harf": "دو",
    "soundFile": "do.mp3",
    "words": [
      {
        "word": "دو بلیاں",
        "imageFile": "do_01.jpg",
        "soundFile": "do_01.mp3"
      },
      {
        "word": "دو پھول",
        "imageFile": "do_02.jpg",
        "soundFile": "do_02.mp3"
      },
      {
        "word": "دو جہاز",
        "imageFile": "do_03.jpg",
        "soundFile": "do_03.mp3"
      },
      {
        "word": "دو کپ",
        "imageFile": "do_04.jpg",
        "soundFile": "do_04.mp3"
      },
      {
        "word": "دو گائیں",
        "imageFile": "do_05.jpg",
        "soundFile": "do_05.mp3"
      },
      {
        "word": "دو مٹکے",
        "imageFile": "do_06.jpg",
        "soundFile": "do_06.mp3"
      }
    ]
  },
  {
    "letter": "teen",
    "harf": "تین",
    "soundFile": "teen.mp3",
    "words": [
      {
        "word": "تین موبائیل فون",
        "imageFile": "teen_01.jpg",
        "soundFile": "teen_01.mp3"
      },
      {
        "word": "تین پرندے",
        "imageFile": "teen_02.jpg",
        "soundFile": "teen_02.mp3"
      },
      {
        "word": "تین ٹوکریاں",
        "imageFile": "teen_03.jpg",
        "soundFile": "teen_03.mp3"
      },
      {
        "word": "تین ڈبے",
        "imageFile": "teen_04.jpg",
        "soundFile": "teen_04.mp3"
      },
      {
        "word": "تین قلم",
        "imageFile": "teen_05.jpg",
        "soundFile": "teen_05.mp3"
      },
      {
        "word": "تین زرافے",
        "imageFile": "teen_06.jpg",
        "soundFile": "teen_06.mp3"
      }
    ]
  },
  {
    "letter": "chaar",
    "harf": "چار",
    "soundFile": "chaar.mp3",
    "words": [
      {
        "word": "چار آم",
        "imageFile": "chaar_01.jpg",
        "soundFile": "chaar_01.mp3"
      },
      {
        "word": "چار کپ",
        "imageFile": "chaar_02.jpg",
        "soundFile": "chaar_02.mp3"
      },
      {
        "word": "چار کرسیاں",
        "imageFile": "chaar_03.jpg",
        "soundFile": "chaar_03.mp3"
      },
      {
        "word": "چار انگلیاں",
        "imageFile": "chaar_04.jpg",
        "soundFile": "chaar_04.mp3"
      },
      {
        "word": "چار گھوڑے",
        "imageFile": "chaar_05.jpg",
        "soundFile": "chaar_05.mp3"
      },
      {
        "word": "چار انڈے",
        "imageFile": "chaar_06.jpg",
        "soundFile": "chaar_06.mp3"
      }
    ]
  },
  {
    "letter": "paanch",
    "harf": "پانچ",
    "soundFile": "paanch.mp3",
    "words": [
      {
        "word": "پانچ انگلیاں",
        "imageFile": "paanch_01.jpg",
        "soundFile": "paanch_01.mp3"
      },
      {
        "word": "پانچ بجے",
        "imageFile": "paanch_02.jpg",
        "soundFile": "paanch_02.mp3"
      },
      {
        "word": "پانچ بطخیں",
        "imageFile": "paanch_03.jpg",
        "soundFile": "paanch_03.mp3"
      },
      {
        "word": "پانچ پنکھڑیاں",
        "imageFile": "paanch_04.jpg",
        "soundFile": "paanch_04.mp3"
      },
      {
        "word": "پانچ دائرے",
        "imageFile": "paanch_05.jpg",
        "soundFile": "paanch_05.mp3"
      },
      {
        "word": "پانچ ستارے",
        "imageFile": "paanch_06.jpg",
        "soundFile": "paanch_06.mp3"
      }
    ]
  },
  {
    "letter": "chhay",
    "harf": "چھ",
    "soundFile": "chhay.mp3",
    "words": [
      {
        "word": "چھ انڈے",
        "imageFile": "chhay_01.jpg",
        "soundFile": "chhay_01.mp3"
      },
      {
        "word": "چھ بوتلیں",
        "imageFile": "chhay_02.jpg",
        "soundFile": "chhay_02.mp3"
      },
      {
        "word": "چھ کنچے",
        "imageFile": "chhay_03.jpg",
        "soundFile": "chhay_03.mp3"
      },
      {
        "word": "چھ کیلے",
        "imageFile": "chhay_04.jpg",
        "soundFile": "chhay_04.mp3"
      },
      {
        "word": "چھ مصالحے",
        "imageFile": "chhay_05.jpg",
        "soundFile": "chhay_05.mp3"
      },
      {
        "word": "چھ نٹ",
        "imageFile": "chhay_06.jpg",
        "soundFile": "chhay_06.mp3"
      }
    ]
  },
  {
    "letter": "saat",
    "harf": "سات",
    "soundFile": "saat.mp3",
    "words": [
      {
        "word": "سات پرندے",
        "soundFile": "saat_01.mp3",
        "imageFile": "saat_01.jpg"
      },
      {
        "word": "سات بجے",
        "imageFile": "saat_02.jpg",
        "soundFile": "saat_02.mp3"
      },
      {
        "word": "سات راج پنس",
        "imageFile": "saat_03.jpg",
        "soundFile": "saat_03.mp3"
      },
      {
        "word": "سات ستارے",
        "imageFile": "saat_04.jpg",
        "soundFile": "saat_04.mp3"
      },
      {
        "word": "سات لیموں",
        "imageFile": "saat_05.jpg",
        "soundFile": "saat_05.mp3"
      },
      {
        "word": "سات مزدور",
        "imageFile": "saat_06.jpg",
        "soundFile": "saat_06.mp3"
      }
    ]
  },
  {
    "letter": "aath",
    "harf": "آٹھ",
    "soundFile": "aath.mp3",
    "words": [
      {
        "word": "آٹھ پنکھڑیاں",
        "imageFile": "aath_01.jpg",
        "soundFile": "aath_01.mp3"
      },
      {
        "word": "آٹھ بجے",
        "imageFile": "aath_02.jpg",
        "soundFile": "aath_02.mp3"
      },
      {
        "word": "آٹھ پرندے",
        "imageFile": "aath_03.jpg",
        "soundFile": "aath_03.mp3"
      },
      {
        "word": "آٹھ ٹانگیں",
        "imageFile": "aath_04.jpg",
        "soundFile": "aath_04.mp3"
      },
      {
        "word": "آٹھ گیندیں",
        "imageFile": "aath_05.jpg",
        "soundFile": "aath_05.mp3"
      },
      {
        "word": "آٹھ لیموں",
        "imageFile": "aath_06.jpg",
        "soundFile": "aath_06.mp3"
      }
    ]
  },
  {
    "letter": "nau",
    "harf": "نو",
    "soundFile": "nau.mp3",
    "words": [
      {
        "word": "نو ٹوکریاں",
        "imageFile": "nau_01.jpg",
        "soundFile": "nau_01.mp3"
      },
      {
        "word": "نو بجے",
        "imageFile": "nau_02.jpg",
        "soundFile": "nau_02.mp3"
      },
      {
        "word": "نو گملے",
        "imageFile": "nau_03.jpg",
        "soundFile": "nau_03.mp3"
      },
      {
        "word": "نو گیندیں",
        "imageFile": "nau_04.jpg",
        "soundFile": "nau_04.mp3"
      },
      {
        "word": "نو لکیریں",
        "imageFile": "nau_05.jpg",
        "soundFile": "nau_05.mp3"
      },
      {
        "word": "نو لیموں",
        "imageFile": "nau_06.jpg",
        "soundFile": "nau_06.mp3"
      }
    ]
  },
  {
    "letter": "das",
    "harf": "دس",
    "soundFile": "das.mp3",
    "words": [
      {
        "word": "دس روپے",
        "imageFile": "das_01.jpg",
        "soundFile": "das_01.mp3"
      },
      {
        "word": "دس بجے",
        "imageFile": "das_02.jpg",
        "soundFile": "das_02.mp3"
      },
      {
        "word": "دس انگلیاں",
        "imageFile": "das_03.jpg",
        "soundFile": "das_03.mp3"
      },
      {
        "word": "دس گاڑیاں",
        "imageFile": "das_04.jpg",
        "soundFile": "das_04.mp3"
      },
      {
        "word": "دس لیموں",
        "imageFile": "das_05.jpg",
        "soundFile": "das_05.mp3"
      },
      {
        "word": "دس گیندیں",
        "imageFile": "das_06.jpg",
        "soundFile": "das_06.mp3"
      }
    ]
  }
];

export default countData;